import React, { useState } from "react";
import { FiArchive } from "react-icons/fi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";

import StyledModal from "components/StyledModal";
import { getErrors } from "helpers/error";
import * as api from "services/api";

import { ButtonsContainer, ContractInfoCard, ModalHeader } from "./styles";

export default function ArchiveContractModal({
	isOpen,
	contract,
	onCancel,
	onArchived,
	onViewArchived
}) {
	const [isLoading, setIsLoading] = useState(false);
	const { token } = useSelector(s => s.login);

	async function handleConfirm() {
		try {
			setIsLoading(true);

			const response = await api.sendPost(
				`/contracts/${contract._id}/archive`,
				null,
				{ Authorization: "Bearer " + token }
			);

			const result = await response.json();

			if (result.isValid) {
				toast.success(
					<span>
						Contrato arquivado. Saiu das pendências do contratante e foi
						registrado como arquivado pelo CS.
						{onViewArchived && (
							<>
								{" "}
								<a
									href="#"
									onClick={event => {
										event.preventDefault();
										toast.dismiss();
										onViewArchived();
									}}
									style={{ textDecoration: "underline", fontWeight: 700 }}
								>
									Ver arquivados
								</a>
							</>
						)}
					</span>
				);
				onArchived && onArchived();
			} else {
				const errors = getErrors(result.errors);
				toast.error(errors.default || "Não foi possível arquivar o contrato.");
			}
		} catch (error) {
			toast.error("Não foi possível arquivar o contrato. Tente novamente.");
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	}

	if (!contract) return null;

	return (
		<StyledModal
			open={isOpen}
			handleClose={onCancel}
			style={{ top: "50%", width: "90%", maxWidth: "440px" }}
		>
			<ModalHeader>
				<FiArchive />
				<div>
					<h1>Arquivar contrato?</h1>
					<p>
						O contrato sairá da lista de pendências do contratante e continuará
						acessível em Contratos arquivados. O registro indicará que foi
						arquivado pelo CS.
					</p>
				</div>
			</ModalHeader>

			<ContractInfoCard>
				<strong>{contract.hired?.businessName}</strong>
				<span>
					Contrato: {contract.template?.name} · Contratante:{" "}
					{contract.mei?.businessName}
				</span>
			</ContractInfoCard>

			<ButtonsContainer>
				<button onClick={onCancel} disabled={isLoading}>
					Cancelar
				</button>
				<button onClick={handleConfirm} disabled={isLoading}>
					{isLoading ? <Spinner size="sm" /> : "Arquivar contrato"}
				</button>
			</ButtonsContainer>
		</StyledModal>
	);
}
